var shop = shop || {};